import { render, staticRenderFns } from "./PerCapitaResults.vue?vue&type=template&id=d48c4b14&scoped=true&"
import script from "./PerCapitaResults.vue?vue&type=script&lang=js&"
export * from "./PerCapitaResults.vue?vue&type=script&lang=js&"
import style0 from "./PerCapitaResults.vue?vue&type=style&index=0&id=d48c4b14&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d48c4b14",
  null
  
)

export default component.exports